import { makeStyles } from '@material-ui/styles';

const HEADER_HEIGHT = 0;

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
  },
  header: {
    height: HEADER_HEIGHT,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.colors.border}`,
  },
  listContainer: {
    width: '100%',
    height: `calc(100% - ${HEADER_HEIGHT}px)`,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatListPage/useStyles.js